import { render, staticRenderFns } from "./IconTriangleBadge.vue?vue&type=template&id=0b7d5b00"
import script from "./IconTriangleBadge.vue?vue&type=script&lang=js"
export * from "./IconTriangleBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports